var render = function render(){var _vm=this,_c=_vm._self._c;return _c('confirm',{attrs:{"not_show_delete_text":"","text":"¿Seguro que quiere resetear el stock a 0?","btn_text":"Resetear","emit":"resetStock","id":"confirm-reset-stock"},on:{"resetStock":_vm.resetStock}})
}
var staticRenderFns = []

export { render, staticRenderFns }